export default __webpack_public_path__ + "static/media/benefit4.599aab96.svg";